import React, { useState } from 'react';
import { useLocalNotificationBanner } from 'Shared/util/custom-hooks';
import { deleteErpIntegration } from 'Shared/util/web-api';
import { ErpIntegrationProviderIdResource } from 'Shared/util/types';
import useBrandContext from 'Contexts/brand-context';
import useCustomerContext from 'Contexts/customer-context';
import Spinner from 'Shared/components/spinner';
import AcconomySettingsCard from './settings-cards/acconomy-settings-card';
import FortnoxSettingsCard from './settings-cards/fortnox-settings-card';
import ManualSettingsCard from './settings-cards/manual-settings-card';
import IntegrationSettingsCard from './settings-cards/integration-settings-card';
import styles from './sales-methods.css';


const SalesMethods = () => {
  const [isDeactivatingIntegration, setIsDeactivatingIntegration] = useState(false);
  const { brandData, loadingBrandData } = useBrandContext();
  const { customerData, loadingCustomerData, updateActiveErpIntegration } = useCustomerContext();
  const {
    NotificationBannerType,
    addLocalNotificationBanner,
    removeAllLocalNotificationBanners,
  } = useLocalNotificationBanner();

  const {
    supportEmailAddress,
    erpIntegration: isErpIntegrationEnabled,
  } = brandData;

  const { activeErpIntegration } = customerData || {};

  const handleDeactivateConfirm = (erpIntegrationProvider: ErpIntegrationProviderIdResource) => {
    removeAllLocalNotificationBanners();
    setIsDeactivatingIntegration(true);

    /* NOTE: React might show an incorrect error ("Warning: Can't perform a React state update on an unmounted component...") if component
    have been unmounted on "setState". This should be fixed in upcoming release https://github.com/facebook/react/pull/22114 */
    deleteErpIntegration({ providerId: erpIntegrationProvider })
      .then(() => updateActiveErpIntegration())
      .catch(() => addLocalNotificationBanner((tnb) => tnb.a_technical_error_occurred_while_deactivating_erp_integration, NotificationBannerType.Error))
      .finally(() => setIsDeactivatingIntegration(false));
  };

  const loading = (loadingBrandData || loadingCustomerData);
  const activeErpIntegrationProviderId = activeErpIntegration?.providerId;

  return (loading
    ? <Spinner />
    : (
      <>
        {isErpIntegrationEnabled && (
          <>
            <AcconomySettingsCard
              active={activeErpIntegrationProviderId === ErpIntegrationProviderIdResource.Acconomy}
              disabled={(isDeactivatingIntegration && activeErpIntegrationProviderId !== ErpIntegrationProviderIdResource.Acconomy) || activeErpIntegrationProviderId === ErpIntegrationProviderIdResource.Undefined}
              onDeactivateConfirm={handleDeactivateConfirm}
              loading={isDeactivatingIntegration && activeErpIntegrationProviderId === ErpIntegrationProviderIdResource.Acconomy}
              className={styles.settingsCardContainer}
            />
            <FortnoxSettingsCard
              active={activeErpIntegrationProviderId === ErpIntegrationProviderIdResource.Fortnox}
              disabled={(isDeactivatingIntegration && activeErpIntegrationProviderId !== ErpIntegrationProviderIdResource.Fortnox) || activeErpIntegrationProviderId === ErpIntegrationProviderIdResource.Undefined}
              onDeactivateConfirm={handleDeactivateConfirm}
              loading={isDeactivatingIntegration && activeErpIntegrationProviderId === ErpIntegrationProviderIdResource.Fortnox}
              className={styles.settingsCardContainer}
            />
          </>
        )}
        <ManualSettingsCard
          disabled={isDeactivatingIntegration}
          className={styles.settingsCardContainer}
        />
        {isErpIntegrationEnabled && (
          <IntegrationSettingsCard
            supportEmailAddress={supportEmailAddress}
            className={styles.settingsCardContainer}
          />
        )}
      </>
    ));
};

export default SalesMethods;
